import { REQUEST, SUCCESS, FAILURE } from 'utils/actionGenerator';
import { GET_RATE_INFOS, SORT_RATE_INFOS } from './actions';
import _get from 'lodash/get';

const defaultState = {
  rateInfos: [],
  fixedRateInfo: {},
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_RATE_INFOS[REQUEST]:
      return {
        ...state,
        rateInfos: [],
        fixedRateInfo: {},
      };

    case GET_RATE_INFOS[SUCCESS]:
      const data = action.response.data?.rateInfos;
      const fixedRateInfo = action.response.data?.fixedRateInfo;
      return {
        ...state,
        rateInfos: data,
        fixedRateInfo: fixedRateInfo,
      };
    case GET_RATE_INFOS[FAILURE]:
      return {
        ...state,
        rateInfos: [],
        fixedRateInfo: {},
      };
    case SORT_RATE_INFOS[REQUEST]:
      return {
        ...state,
        // TODO: sorting functions goes here...
      };
    default:
      return {
        ...state,
      };
  }
}

export const getRateInfosState = (state) => _get(state, 'placement.rateInfoTab.rateInfos');
export const getFixedRateInfosState = (state) => _get(state, 'placement.rateInfoTab.fixedRateInfo');
